import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * RouteTracker — sends a GA4 `page_view` event on the initial load and on
 * every client-side route change. Mounted once inside <BrowserRouter>.
 * Renders nothing.
 *
 * We wait a microtask so the page's <title> (set per-page via useSeo) has
 * landed before we read document.title for the event.
 */
export function RouteTracker() {
  const { pathname, search } = useLocation();
  const lastPath = useRef<string>("");

  useEffect(() => {
    const path = pathname + search;
    if (path === lastPath.current) return;
    lastPath.current = path;
    const t = setTimeout(() => trackPageView(path), 0);
    return () => clearTimeout(t);
  }, [pathname, search]);

  return null;
}
